import { render, staticRenderFns } from "./GreensInRegulationPieChart.vue?vue&type=template&id=823d246c&"
import script from "./GreensInRegulationPieChart.vue?vue&type=script&lang=js&"
export * from "./GreensInRegulationPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports